import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

type EmbedeInstructionsProps = {
  width?: string;
  height?: string;
  mostrarSecaoGarantias?: boolean;
};

const EmbedeInstructionsComponent = ({
  width = "80vw",
  height = "80vh",
  mostrarSecaoGarantias = false,
}: EmbedeInstructionsProps) => {
  const [open, setOpen] = useState(false);

  const iframeSrc = mostrarSecaoGarantias
    ? "/configuracoes/ajuda?garantias=1"
    : "/configuracoes/ajuda";

  return (
    <>
      <Button
        style={{
          marginRight: "8%",
          padding: "0 16px",
          flexShrink: 0,
        }}
        variant="contained"
        onClick={() => setOpen(!open)}
      >
        Instruções
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        fullScreen={false}
        maxWidth="xl"
        PaperProps={{ style: { width, height: "90vh", maxWidth: "90vw" } }}
      >
        <DialogTitle>
          Instruções
          <IconButton
            onClick={() => setOpen(false)}
            style={{ position: "absolute", right: 10, top: 10 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          style={{ padding: 0, height: "100%", overflow: "hidden" }}
        >
          <iframe
            title="Instruções"
            src={iframeSrc}
            style={{ border: "none", width: "100%", height: "100%" }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
export default EmbedeInstructionsComponent;
